'use client';

import { useEffect } from 'react';

const SSO_DASHBOARD_PATHS = [
  '/employee-dashboard',
  '/customer-portal',
  '/owner-dashboard',
];

function isSsoDashboard(pathname: string) {
  return (
    SSO_DASHBOARD_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`)) ||
    pathname === '/aac/workshop-cms' ||
    pathname.startsWith('/aac/workshop-cms/') ||
    pathname.startsWith('/emp-login/dashboard/workshop-cms/')
  );
}

export default function SsoLogoutInterceptor() {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const button = target?.closest('button');
      if (!button || !isSsoDashboard(window.location.pathname)) return;

      const text = (button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!/\bsign\s*out\b/.test(text)) return;

      event.preventDefault();
      event.stopPropagation();

      [
        'aac-employee-token',
        'aac-employee-user',
        'aac-customer-token',
        'aac-customer-user',
        'aac-customer-organizations',
        'aac-owner-token',
        'aac-owner-user',
        'aac-client-id',
      ].forEach((key) => localStorage.removeItem(key));

      window.location.assign('/auth/sso-logout');
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
}
